<template>
  <div>
    <div v-if="Lib.checkPower('beauty-3-ckgkxfjl2',2)" class="commonTable">
      <el-table v-loading="loading" :data="tableData" tooltip-effect="light">
        <el-table-column prop="orderCode" label="订单号" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="createTime" label="开单时间" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            {{ scope.row.createTime || '--' }}
          </template>
        </el-table-column>
        <el-table-column label="订单类型">
          <template slot-scope="scope">
            <span class="consumeGray">{{ Lib.getOrderTypeName(scope.row.orderType) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orderAmount" label="收入金额（元）" :show-overflow-tooltip="true">
          <template slot="header" slot-scope="scope">
            <span v-show="scope">收入金额（元）</span>
            <el-tooltip placement="top-start" effect="light" content="收入金额=实收金额+划扣金额">
              <i class="el-icon-warning"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="orderAmount" label="订单状态" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{ scope.row.orderStatus==1 ?'待结算': scope.row.orderStatus==2 ?'已结算':scope.row.orderStatus==3 ?'部分支付':'已退款' }}
        </template>
      </el-table-column> -->
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <yz-btn type="primary" @click="orderDetails(scope.row)">查看</yz-btn>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="tableData.length > 0" class="blockThree">
        <el-pagination background :current-page.sync="pageNum" :page-size="10" layout="prev, pager, next, jumper" :total="rowCount" @size-change="handleSizeChange" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
    <gt-noneData v-else :title="'暂无权限，请联系管理员分配权限'" :is-no-permission="true"></gt-noneData>
  </div>
</template>

<script>
import { getExpenseListByPhone } from '../api';

export default {
  data() {
    return {
      phone: '', // 顾客手机
      tableData: [], // 预约列表信息
      pageNum: 1, // 列表页码
      rowCount: 1, // 列表总数
      // 5.7
      loading: true,
    };
  },
  activated() {
    this.phone = window.sessionStorage.customerPhone;
    this.getListData(1);
  },
  methods: {
    getListData(val) {
      this.loading = true;
      this.pageNum = val;
      const data = {
        pageNum: this.pageNum,
        phone: this.phone
      };
      getExpenseListByPhone(data).then((res) => {
        this.tableData = res.data.records;
        this.rowCount = res.data.total;
        this.pageSize = res.data.size;
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.getListData(val);
    },
    handleCurrentChange(val) {
      this.getListData(val);
    },
    orderDetails(v) {
      window.sessionStorage.orderData = window.JSON.stringify(v);
      this.$router.push({
        name: 'stage-orderDeatilsData',
        params: {
          orderId: v.orderId,
          orderType: v.orderType
        }
      });
    }
  }
};
</script>
